const transitionTimingFunction = 'ease-in-out';
const transitionDuration = '300ms';
const transitionValue = `all ${transitionDuration} ${transitionTimingFunction}`;
export const Animation = {
    transitionTimingFunction,
    transitionDuration,
    transitionValue,
};
//# sourceMappingURL=Animation.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
